import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useState } from 'react';
import { subscribeToNewBlock, useReadonlyNetworks, useWindow } from '../providers';
import { useConnector } from '../providers/network/connectors';
import { useChainId } from './useChainId';
import { useDebounce } from './useDebounce';
import { useIsMounted } from './useIsMounted';
/**
 * Get the current block number.
 * Will update automatically when the new block is mined.
 * @public
 */
export function useBlockNumber() {
  var chainId = useChainId();
  var readOnlyNetworks = useReadonlyNetworks();
  var _useConnector = useConnector(),
    connector = _useConnector.connector;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    blockNumber = _useState2[0],
    setBlockNumber = _useState2[1];
  var isActive = useWindow();
  var isMounted = useIsMounted();
  useEffect(function () {
    if (!isActive) {
      return;
    }
    var readOnlyNetwork = chainId && readOnlyNetworks[chainId];
    if (readOnlyNetwork) {
      var _unsub = subscribeToNewBlock(readOnlyNetwork, chainId, function (_ref) {
        var blockNumber = _ref.blockNumber;
        if (isMounted()) {
          setBlockNumber(blockNumber);
        }
      }, isActive);
      return function () {
        return _unsub();
      };
    }
    if (!connector) {
      return;
    }
    var unsub = connector.newBlock.on(function (blockNumber) {
      if (isMounted()) {
        setBlockNumber(blockNumber);
      }
    });
    return function () {
      return unsub();
    };
  }, [isActive, readOnlyNetworks, connector, chainId]);
  var debouncedBlockNumber = useDebounce(blockNumber, 100);
  return debouncedBlockNumber;
}